import {
  getTemplates,
  deleteTemplate as deleteTemplateRequest,
} from '~/api/templates';

import {
  setTemplates,
  deleteTemplate as deleteTemplateAction,
} from '~/actions/media_storage';

import { ErrorMessageTemplateType } from '~/constants/messages';

export const fetchTemplates =
  ({ limit = 9999, offset = 0, type } = {}) =>
  async (dispatch) => {
    const { templates } = await getTemplates({
      limit,
      offset,
      type,
    });

    dispatch(
      setTemplates(
        templates.map((template) => ({
          ...template,
          id: template._id,
        }))
      )
    );
  };

export const deleteTemplate =
  ({ TEMPLATE_TYPE, enqueueSnackbar, templateId, callback, errorCallback }) =>
  async (dispatch) => {
    try {
      await deleteTemplateRequest(templateId);

      dispatch(deleteTemplateAction(templateId));

      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      enqueueSnackbar(
        error.message || ErrorMessageTemplateType[TEMPLATE_TYPE],
        {
          variant: 'error',
        }
      );

      if (typeof errorCallback === 'function') {
        errorCallback();
      }
    }
  };
